<script setup lang="ts">
// Glassmorphism cinematic card
</script>

<template>
  <div class="babel-card">
    <slot />
  </div>
</template>
